import React from 'react';
import PropTypes from 'prop-types';
import Message from '../../../messages-notifications/messages/to-refactor/detail/Message';

export class MessagesList extends React.Component {

    render() {
        const {
            data,
            error,
            canResponseMessage,
        } = this.props;

        if ( error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{error}</h3>
                </section>
            );
        }

        return (
            <div>
                {
                    data.map((message) => {
                        return (
                            <Message
                                key={message.id()}
                                message={message}
                                canResponse={canResponseMessage}
                                canArchive={canResponseMessage}
                                showDivider={true}
                            />
                        );
                    })
                }
            </div>
        );
    }

}

MessagesList.propTypes = {
    data: PropTypes.array,
    error: PropTypes.string,
    canResponseMessage: PropTypes.bool,
};

MessagesList.defaultProps = {
    canResponseMessage: true,
};



// WEBPACK FOOTER //
// ./src/app/shared/message/list/MessagesList.jsx